export default "__VITE_ASSET__CV78iDPg__"